import { Box, Typography, styled } from "@mui/material";
import { CustomDisplayItem } from "@/components/custom/custom-display-item";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(4),
}));

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const sections = [
  {
    key: "routingTypes",
    label: "Routing Types",
    description: "Setup routing types",
  },
  {
    key: "processors",
    label: "Processors",
    description: "Setup routing processors",
  },
  {
    key: "cardTypes",
    label: "Card Types",
    description: "Setup card types",
  },
];

const RoutingConfiguration = ({ data }) => {
  return (
    <Wrapper>
      {sections.map(({ key, label, description }) => {
        const items = data?.[key] ?? [];

        return (
          <Row key={key}>
            <Side>
              <Typography
                variant="h5"
                sx={{ fontSize: "1rem" }}
                fontWeight={500}
              >
                {label}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            </Side>

            <Grid>
              {items.length > 0 ? (
                items.map((item) => (
                  <Box sx={{ backgroundColor: "background.paper" }}>
                    <CustomDisplayItem
                      key={item.code}
                      label={item.code}
                      value={item.name}
                    />
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No {label.toLowerCase()} configured.
                </Typography>
              )}
            </Grid>
          </Row>
        );
      })}
    </Wrapper>
  );
};

export default RoutingConfiguration;
